import { AlertCircleIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export default function ErrorView() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="bg-background flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Alert
          variant="error"
          className="flex flex-col items-center gap-4 py-8"
        >
          <AlertCircleIcon className="text-destructive h-12 w-12" />
          <div className="space-y-2 text-center">
            <AlertTitle className="text-xl font-semibold">
              Bir Hata Oluştu
            </AlertTitle>
            <AlertDescription className="text-muted-foreground">
              Üzgünüz, beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin
              veya daha sonra tekrar deneyin.
            </AlertDescription>
          </div>
          <Button onClick={handleReload} variant="default" className="mt-4">
            Sayfayı Yenile
          </Button>
        </Alert>
      </div>
    </div>
  );
}
